<div class="container">
    <span class="subtle last-update" *ngIf="vulnerabilities">
        {{
            'PAGES.VULNERABILITIES.LAST_UPDATE' | translate : { value: vulnerabilities.lastUpdate }
        }}
    </span>
    <div class="title">
        <h1>{{ 'PAGES.VULNERABILITIES.TITLE' | translate }}</h1>
        <div>
            <a (click)="redirectToHelpCenter()">{{ 'COMMON.HELP_CENTER' | translate }}</a>
            <app-language-select></app-language-select>
        </div>
    </div>
    <div [showLoadingSpinner]="loadingService.isLoading(this)">
        <ng-container *ngIf="vulnerabilities">
            <div class="section" *ngIf="vulnerabilities.active.length">
                <ng-template
                    *ngTemplateOutlet="
                        vulnerabilitiesSectionTemplate;
                        context: {
                            section: {
                                title: 'ACTIVE',
                                vulnerabilities: vulnerabilities.active
                            }
                        }
                    "
                ></ng-template>
            </div>

            <div class="section" *ngIf="vulnerabilities.archived.length">
                <ng-template
                    *ngTemplateOutlet="
                        vulnerabilitiesSectionTemplate;
                        context: {
                            section: {
                                title: 'ARCHIVED',
                                vulnerabilities: vulnerabilities.archived
                            }
                        }
                    "
                ></ng-template>
            </div>
        </ng-container>

        <ng-container *ngIf="isEmpty">
            <div class="empty-status">
                <app-empty-state [type]="emptyState.type" [helpCenterLink]="{ display: true }">
                    <div title>
                        {{ emptyState.title }}
                    </div>
                    <div message [innerHTML]="emptyState.message"></div>
                </app-empty-state>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #vulnerabilitiesSectionTemplate let-section="section">
    <h2>{{ 'PAGES.VULNERABILITIES.' + section.title | translate }}</h2>

    <div class="vulnerabilities" *ngFor="let vulnerability of section.vulnerabilities">
        <ng-template
            *ngTemplateOutlet="vulnerabilityTemplate; context: { $implicit: vulnerability }"
        ></ng-template>
    </div>
</ng-template>

<ng-template #vulnerabilityTemplate let-vulnerability>
    <div class="vulnerability">
        <p class="strong">{{ vulnerability.date | titlecase }}</p>
        <p>{{ vulnerability.description }}</p>
        <p class="subtle">{{ vulnerability.resolution }}</p>

        <div class="resources">
            <div *ngIf="vulnerability.resources.manuals.length">
                <ng-template
                    *ngTemplateOutlet="
                        resourcesTemplate;
                        context: { icon: 'description', resources: vulnerability.resources.manuals }
                    "
                ></ng-template>
            </div>
            <div *ngIf="vulnerability.resources.download.length">
                <ng-template
                    *ngTemplateOutlet="
                        resourcesTemplate;
                        context: { icon: 'download', resources: vulnerability.resources.download }
                    "
                ></ng-template>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #resourcesTemplate let-icon="icon" let-resources="resources">
    <mat-icon>{{ icon }}</mat-icon>
    <span>
        <span *ngFor="let resource of resources; let last = last">
            <a (click)="openResourceLink(resource.link)">{{ resource.text }}</a>
            <ng-container *ngIf="!last">, </ng-container>
        </span>
    </span>
</ng-template>
